import dayjs from "dayjs";

interface AbortInstance {
  target?: AbortController;
}

let abortInstance: AbortInstance = {};

export { abortInstance };

/**
 * 指定毫秒数后Promise决议成功
 * @param {number} timeout
 * @returns
 */
export function timeoutResolve(timeout = 3000) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(void 0);
    }, timeout);
  });
}

/**
 * 指定毫秒数后Promise决议失败
 * @param timeout 时间戳
 * @returns Promise
 */
export function timeoutReject(timeout = 3000) {
  return new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error("timeout"));
    }, timeout);
  });
}

/**
 * 时间格式化
 * @param time 时间戳/合法的时间格式字符串
 * @param format 时间格式
 * @returns 格式化后的时间字符串
 */
export function formatTime(
  time: number | string,
  format: string = "YYYY-MM-DD HH:mm:ss"
) {
  if (!time) {
    return "";
  }
  return dayjs(time).format(format);
}
// 合并对象
export const mergeDefaultStateToPageState = (
  options: { [x: string]: any },
  props: { [x: string]: any }
) => {
  for (const key in options) {
    if (!Object.getOwnPropertyDescriptor(props, key)) {
      props[key] = options[key];
    }
  }
  return props;
};

export function getGUID(prefix: string = ""): string {
  var uuid = "",
    i,
    random;
  for (i = 0; i < 16; i++) {
    random = (Math.random() * 16) | 0;
    if (i == 8) {
      uuid += "-";
    }
    uuid += (i == 12 ? 4 : i == 16 ? (random & 3) | 8 : random).toString(16);
  }
  return prefix + uuid;
}
export function getShortGUID(prefix: string = ""): string {
  var uuid = "",
    i,
    random;
  for (i = 0; i < 12; i++) {
    random = (Math.random() * 16) | 0;
    if (i == 8) {
      uuid += "-";
    }
    uuid += (i == 4 ? 4 : i == 6 ? (random & 3) | 8 : random).toString(12);
  }
  return prefix + uuid;
}

export function getPartialProperty(partial: object, fullObj: object): object {
  const res = {};
  for (const key of Object.keys(partial)) {
    if (Object.prototype.toString.call(partial[key]) === "[object Object]") {
      res[key] = getPartialProperty(partial[key], fullObj[key]);
    } else {
      res[key] = fullObj[key];
    }
  }
  return res;
}

/**
 * 分时函数封装
 * @description 用于将任务函数数组按照一定的调度器进行分时执行，可以避免一次性执行过多任务导致的性能问题。
 * example:
 * performTasks(Array.from({length: 10000}, (_, index) => () => {
 *  const div = document.createElement("div");
 *  div.innerText = index.toString();
 *  document.body.appendChild(div);
 * }), (chunk: Function) => {
 *  let count = 0;
 *  setTimeout(() => {
 *    chunk(() => count++ < 3);
 *  }, 1000);
 * });
 * @param tasks 任务函数数组
 * @param scheduler 调度器
 * @returns void
 */
export function performTasks(tasks: Function[], scheduler: Function): void {
  if (tasks.length === 0) {
    return;
  }
  let index = 0;
  function _run() {
    scheduler((isGoOn: Function) => {
      while (index < tasks.length && isGoOn()) {
        tasks[index++]();
      }
      if (index < tasks.length) _run();
    });
  }
  _run();
}

/**
 * 使用requestIdleCallback调度器执行分时任务
 * @param tasks 任务函数数组
 */
export function idlePerformTasks(tasks: Function[]) {
  performTasks(tasks, (chunk: Function) => {
    requestIdleCallback(idle => {
      chunk(() => idle.timeRemaining() > 0);
    });
  });
}

export function debounce(
  func: { apply: (arg0: any, arg1: any[]) => void },
  wait: number | undefined
) {
  let timeout;
  return function (...args: any) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}